export { default as InfoIcon } from '~icons/tabler/info-small';
